module.exports = __webpack_public_path__ + "img/server-rack.94ed5c4a.jpg";